import React from 'react';

/**
 * StatStrip — 3-4 column row of value/label pairs.
 * data: { items: [{ value, label }] }
 */
export default function StatStrip({ data = {} }) {
  const items = data.items || [];
  if (items.length === 0) return null;
  return (
    <section className="border-y orka-border-subtle" data-testid="site-block-stat-strip">
      <div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map((it, i) => (
          <div key={i} className="text-center md:text-left" data-testid={`site-block-stat-${i}`}>
            <div className="text-3xl lg:text-4xl font-bold orka-text-primary font-mono tabular-nums">
              {it.value}
            </div>
            <div className="mt-1 text-xs uppercase tracking-wider orka-text-tertiary font-semibold">
              {it.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
